/**
 * Convert template element to div.
 * for video iframes in video-block and linkedContentBannerBlock.
 * 
 */

// Grab triggers
const triggers = document.querySelectorAll('.contains-video-frame');

// Add eventlisteners
if (triggers.length) {
    for (let i = 0; i < triggers.length; i++) {
        triggers[i].addEventListener('click', () => changeTemplateToDiv(triggers[i]));
    }
}

// Remove listeners on beforeunload
window.addEventListener('beforeunload', () => {
    if (triggers.length) {
        for (let i = 0; i < triggers.length; i++) {
            triggers[i].removeEventListener('click', () => changeTemplateToDiv(triggers[i]));
        }
    }
});


function changeTemplateToDiv(trigger) {
    // Replace template for a div with the same contents
    let template = trigger.querySelector('template');

    if (template) {
        let parent = template.parentNode;
        let content = template.innerHTML;

        let replacementDiv = document.createElement('div');
        replacementDiv.classList.add('video-wrapper');
        replacementDiv.innerHTML = content;

        parent.replaceChild(replacementDiv, template);
    }
}